(() => {
  if (window.lpHomeV4) return;
  window.lpHomeV4 = true;
  const instances = new WeakMap();
  const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const arrow = '<svg class="ic" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  function init(root) {
    if (instances.has(root)) return;
    const abort = new AbortController(), signal = abort.signal;
    instances.set(root, abort);
    const $ = id => root.querySelector(`[data-lp-id="${id}"]`);
    const on = (el, event, fn) => el?.addEventListener(event, fn, {signal});
    const scroll = el => el?.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});
    if (root.dataset.homeModule === 'lp-home-reviews') {
      const track = $('rv-track');
      on($('rv-prev'), 'click', () => track.scrollBy({left: -(track.querySelector('.rv').offsetWidth + 18), behavior:'smooth'}));
      on($('rv-next'), 'click', () => track.scrollBy({left: track.querySelector('.rv').offsetWidth + 18, behavior:'smooth'}));
      return;
    }
    const configNode = root.querySelector('[data-lp-home-data]');
    if (!configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (error) { console.error('Homepage settings could not be loaded', error); return; }
    const products = config.products;
    if (!products.length) return;
    const isContact = root.dataset.homeModule === 'lp-contact-quote';
    const storagePrefix = isContact ? 'lp-contact-'+location.pathname : 'lp-home';
    const selectionKey = storagePrefix+'-selection';
    const Q = {prod:Math.min(1,products.length-1),types:new Set(),qty:0,step:1};
    if (isContact) {
      const requested = new URLSearchParams(location.search).get('product_type')?.toLowerCase();
      const matched = products.findIndex(p => p.label.toLowerCase()===requested || (requested==='boxes & trays' && p.label==='Boxes'));
      if(matched>=0)Q.prod=matched;
    }
    const quantities = () => config.quantities[products[Q.prod].qty] || config.quantities.k1000;
    if(root.querySelector('.lp-form-error') || root.querySelector('[data-lp-success="true"]')) {
      try {
        const saved=JSON.parse(sessionStorage.getItem(selectionKey)||'null');
        if(saved && products[saved.prod]) {
          Q.prod=saved.prod;Q.qty=quantities()[saved.qty]?saved.qty:0;
          Q.types=new Set((saved.types||[]).filter(t=>products[Q.prod].types.includes(t)));
        }
      } catch(error) {}
    }
    const modal = $('mm');
    const successDialog = $('success-dialog');
    let successOverflow = '';
    on($('success-dismiss'),'click',()=>successDialog.close());
    on(successDialog,'close',()=>{document.body.style.overflow=successOverflow;$('pane-3')?.focus({preventScroll:true});});
    let modalReturn, priorOverflow = '';
    function renderStep1() {
      $('prod-grid').innerHTML = products.map((p,i) => `<button type="button" class="prod" aria-pressed="${i===Q.prod}" data-p="${i}">${p.thumb?`<img src="${esc(p.thumb)}" width="42" height="42" alt="" loading="lazy">`:''}<span>${esc(p.label)}</span></button>`).join('');
      const p = products[Q.prod];
      $('type-meta').textContent = p.meta + ' · select any';
      $('type-browse').textContent = 'Browse ' + p.label + ' →';
      $('type-browse').href = p.url || '/collections/all-products';
      $('type-chips').innerHTML = p.types.filter(Boolean).map(t => `<button type="button" class="chip" aria-pressed="${Q.types.has(t)}" data-t="${esc(t)}">${esc(t)}</button>`).join('');
      $('qty-grid').innerHTML = quantities().map(([l],i) => `<button type="button" class="qty" aria-pressed="${i===Q.qty}" data-q="${i}"><b>${esc(l)}</b></button>`).join('');
    }
    function setStep(n) {
      Q.step = n;
      [1,2,3].forEach(i => $('pane-'+i).hidden = isContact && n !== 3 ? i === 3 : i !== n);
      root.querySelectorAll('.q-step').forEach(el => {el.classList.toggle('on',+el.dataset.s===n);el.classList.toggle('done',+el.dataset.s<n);if(+el.dataset.s===n)el.setAttribute('aria-current','step');else el.removeAttribute('aria-current');});
      root.querySelectorAll('.q-bar').forEach(el => el.classList.toggle('on',+el.dataset.b<n));
      if (n===2 && !isContact) {
        $('sum-img').src = products[Q.prod].thumb;
        $('sum-title').textContent = products[Q.prod].label + (Q.types.size?' · '+[...Q.types].join(', '):'');
        $('sum-sub').textContent = quantities()[Q.qty][0] + ' pcs';
      }
      scroll($('quote'));
    }
    function renderModal() {
      const p = products[Q.prod];
      $('mm-img').src = p.thumb;
      $('mm-prod').textContent = p.label+(Q.types.size?' · '+[...Q.types].join(', '):'');
      $('mm-qty').textContent = quantities()[Q.qty][0]+' pcs · '+p.meta;
      $('mm-prods').innerHTML = products.map((p,i)=>`<button type="button" class="chip" aria-pressed="${i===Q.prod}" data-p="${i}">${esc(p.label)}</button>`).join('');
      $('mm-types').innerHTML = p.types.filter(Boolean).map(t=>`<button type="button" class="chip" aria-pressed="${Q.types.has(t)}" data-t="${esc(t)}">${esc(t)}</button>`).join('');
      $('mm-qtys').innerHTML = quantities().map(([l],i)=>`<button type="button" class="chip" aria-pressed="${i===Q.qty}" data-q="${i}">${esc(l)}</button>`).join('');
    }
    function openModal(success=false) {
      if(!modal)return;
      modalReturn=document.activeElement;priorOverflow=document.body.style.overflow;
      renderModal();modal.hidden=false;document.body.style.overflow='hidden';
      root.querySelector('[data-lp-form="mm-form"]').closest('form').hidden=success;
      $('mm-done').hidden=!success;modal.scrollTop=0;$('mm-close').focus();
    }
    function closeModal() {modal.hidden=true;document.body.style.overflow=priorOverflow;modalReturn?.focus();}
    function goQuote(){scroll($('quote'));}
    on(root,'click',event=>{
      const target=event.target.closest('button');if(!target)return;
      const control=['p','t','q'].find(key=>target.dataset[key]!==undefined);
      const controlValue=control?target.dataset[control]:null;
      const controlGroup=target.parentElement;
      if(target.dataset.p!==undefined){Q.prod=+target.dataset.p;Q.qty=0;Q.types.clear();renderStep1();if(modal&&!modal.hidden)renderModal();}
      else if(target.dataset.t!==undefined){const t=target.dataset.t;Q.types.has(t)?Q.types.delete(t):Q.types.add(t);renderStep1();if(modal&&!modal.hidden)renderModal();}
      else if(target.dataset.q!==undefined){Q.qty=+target.dataset.q;renderStep1();if(modal&&!modal.hidden)renderModal();}
      else if(target===$('to-step-2')){setStep(2);$('in-name').focus({preventScroll:true});}
      else if(target===$('sum-edit')||target===$('back-1')){setStep(1);$('prod-grid').querySelector('[aria-pressed="true"]')?.focus({preventScroll:true});}
      else if(target===$('open-mockup'))openModal();
      else if(target===$('mm-close')||target===$('mm-back'))closeModal();
      if(control) [...controlGroup.querySelectorAll('button')].find(b=>b.dataset[control]===controlValue)?.focus({preventScroll:true});
    });
    on(document,'click',event=>{
      if(document.querySelector('[data-home-module="lp-home-hero"]')!==root)return;
      const cta=event.target.closest('.js-quote,[data-lp-id="open-mockup-2"]');
      if(!cta)return;event.preventDefault();if(cta.dataset.lpId==='open-mockup-2')openModal();else goQuote();
    });
    on(modal,'click',event=>{if(event.target===modal)closeModal();});
    on(document,'keydown',event=>{
      if(!modal || modal.hidden)return;
      if(event.key==='Escape')closeModal();
      if(event.key==='Tab'){
        const els=[...modal.querySelectorAll('button,a[href],input,select,textarea')].filter(el=>!el.disabled&&el.getClientRects().length);
        const first=els[0],last=els[els.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      }
    });
    for (const [fileId,labelId] of [['in-file','file-label'],['mm-file','mm-file-label']]) {
      on($(fileId),'change',event=>{
        const file=event.target.files[0];
        const form=event.target.closest('form');
        form.querySelector('[name="contact[file_upload_url]"]').value='';
        form.querySelector('[name="contact[file_upload_name]"]').value='';
        $(labelId).textContent=file?'Attached: '+file.name:'Upload your logo or artwork';
        $(fileId).closest('label')?.classList.toggle('has',!!file);
      });
    }
    function status(form,message,error=false){
      let box=form.querySelector('[data-form-status]');
      if(!box){box=document.createElement('p');box.dataset.formStatus='';box.setAttribute('role','status');form.append(box);}
      box.textContent=message;box.className=error?'lp-form-error':'q-note';
    }
    for(const wrapper of root.querySelectorAll('[data-lp-form]')){
      const form=wrapper.closest('form'),isMock=wrapper.dataset.lpForm==='mm-form';
      const prefix=isMock?'mm-':'in-';
      const phone=$(prefix+'phone');if(phone)phone.required=true;
      [prefix+'name',prefix+'email'].forEach(id=>{if($(id))$(id).required=true;});
      if(isMock){$('mm-file').required=true;$('mm-size').required=true;}
      on(form,'submit',async event=>{
        if(form.dataset.submitting==='true'){event.preventDefault();return;}
        const mode=event.submitter?.dataset.mode||form.querySelector('[name="contact[continue_option]"]').value||'quote';
        form.querySelector('[name="contact[continue_option]"]').value=mode;
        form.querySelector('[name="contact[product_type]"]').value=products[Q.prod].label+(Q.types.size?' · '+[...Q.types].join(', '):'');
        form.querySelector('[name="contact[quantity]"]').value=quantities()[Q.qty][0];
        if(phone&&phone.value.replace(/\D/g,'').length<6){event.preventDefault();phone.setCustomValidity('Please enter a valid phone or WhatsApp number.');phone.reportValidity();return;}
        const file=$(isMock?'mm-file':'in-file').files[0];
        const fileUrl=form.querySelector('[name="contact[file_upload_url]"]');
        if(file&&!fileUrl.value){
          event.preventDefault();
          if(file.size>20*1024*1024){status(form,'Please use a file under 20 MB, or share a file link in your message.',true);return;}
          if(!config.cloud||!config.preset){status(form,'File upload is unavailable. Please share an artwork link in your message.',true);return;}
          const submitter=event.submitter;
          form.dataset.submitting='true';form.querySelectorAll('[type="submit"]').forEach(b=>b.disabled=true);status(form,'Uploading artwork…');
          try{
            const body=new FormData();body.append('file',file);body.append('upload_preset',config.preset);if(config.folder)body.append('folder',config.folder);
            const response=await fetch('https://api.cloudinary.com/v1_1/'+encodeURIComponent(config.cloud)+'/auto/upload',{method:'POST',body});
            const result=await response.json();if(!response.ok||!result.secure_url)throw Error('Upload failed');
            fileUrl.value=result.secure_url;form.querySelector('[name="contact[file_upload_name]"]').value=file.name;
            status(form,'Artwork uploaded. Sending your request…');
          }catch(error){status(form,'Upload failed. Please retry or share an artwork link in your message.',true);return;}
          finally{form.dataset.submitting='';form.querySelectorAll('[type="submit"]').forEach(b=>b.disabled=false);}
          form.requestSubmit(submitter);return;
        }
        try{sessionStorage.setItem(storagePrefix+'-last-form',form.id);sessionStorage.setItem(storagePrefix+'-continue',mode);sessionStorage.setItem(selectionKey,JSON.stringify({prod:Q.prod,qty:Q.qty,types:[...Q.types]}));}catch(error){}
        form.dispatchEvent(new CustomEvent('lp:inquiry:submit'));
        // Shopify owns contact delivery and captcha. The success panel is rendered only after its response.
      });
      on(phone,'input',()=>phone.setCustomValidity(''));
    }
    renderStep1();
    let lastForm='',continueMode='';try{lastForm=sessionStorage.getItem(storagePrefix+'-last-form')||'';continueMode=sessionStorage.getItem(storagePrefix+'-continue')||'';}catch(error){}
    const successWrappers=[...root.querySelectorAll('[data-lp-success="true"]')];
    const success=successWrappers.find(w=>w.closest('form').id===lastForm)||successWrappers[0];
    if(success){
      if(success.dataset.lpForm!=='mm-form')setStep(3);
      if(continueMode==='call'&&config.schedule){
        const a=document.createElement('a');a.className='btn btn-primary';a.href=config.schedule;a.target='_blank';a.rel='noopener';a.textContent='Choose a time for your call';
        (successDialog?.querySelector('.done-btns')||(success.dataset.lpForm==='mm-form'?$('mm-done'):$('pane-3'))).append(a);
      }
      if(successDialog&&typeof successDialog.showModal==='function'){
        successOverflow=document.body.style.overflow;
        successDialog.showModal();document.body.style.overflow='hidden';
      }else if(successDialog){
        window.alert(successDialog.querySelector('h3').textContent+'\n\n'+successDialog.querySelector('p').textContent);
      }else if(success.dataset.lpForm==='mm-form'){
        openModal(true);
      }
    }else if(root.querySelector('.lp-form-error'))setStep(2);
    signal.addEventListener('abort',()=>{if(successDialog?.open){successDialog.close();document.body.style.overflow=successOverflow;}if(modal&&!modal.hidden)document.body.style.overflow=priorOverflow;});
  }
  const scan=scope=>scope.querySelectorAll('.lp-home-root').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.lp-home-root').forEach(root=>instances.get(root)?.abort()));
})();
